"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidParamsError = exports.NotFoundError = exports.ForbiddenError = exports.AppError = exports.INTERNAL_ERROR_CODE = void 0;
/** we keep this the same as apollo */
exports.INTERNAL_ERROR_CODE = 'INTERNAL_SERVER_ERROR';
// we do not extend from graphql error so we can reuse errors more easily at other parts of the app as well
class AppError extends Error {
    /**
     * @param statusCode while graphql doesn't use status codes for errors, we want to know what status code an error represent to increase our logging capabilities
     */
    constructor(message, code, statusCode, extensions) {
        super(message);
        this.code = code;
        this.statusCode = statusCode;
        // we follow the extension pattern just like in graphql to make the default error handling in our app better
        this.extensions = {
            ...(extensions ?? {}),
            code,
        };
    }
}
exports.AppError = AppError;
class ForbiddenError extends AppError {
    constructor(message = 'Forbidden', extensions) {
        super(message, 'FORBIDDEN', 403, extensions);
        Object.defineProperty(this, 'name', { value: 'ForbiddenError' });
    }
}
exports.ForbiddenError = ForbiddenError;
class NotFoundError extends AppError {
    constructor(message = 'Not-found', extensions) {
        super(message, 'NOT-FOUND', 404, extensions);
        Object.defineProperty(this, 'name', { value: 'NotFoundError' });
    }
}
exports.NotFoundError = NotFoundError;
class InvalidParamsError extends AppError {
    constructor(message = 'Invalid params received', extensions) {
        super(message, 'INVALID_PARAMS', 400, extensions);
        Object.defineProperty(this, 'name', { value: 'InvalidParamsError' });
    }
}
exports.InvalidParamsError = InvalidParamsError;
//# sourceMappingURL=shared.errors.js.map